import { CheckboxIndicator, Checkbox as ReactCheckbox } from '@radix-ui/react-checkbox';
import classNames from 'classnames';
import { Check, Minus } from 'phosphor-react';
import type { MouseEventHandler, PropsWithChildren } from 'react';

export type CheckboxProps = {
  id?: string;
  className?: string;
  disabled?: boolean;
  value: boolean | 'indeterminate';
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  onValueChange?: (value: boolean) => void;
};

export function Checkbox(props: PropsWithChildren<CheckboxProps>) {
  return (
    <ReactCheckbox
      id={props.id}
      onClick={props.onClick}
      className={classNames(
        'w-300 h-300 tds-checkbox',
        props.className,
      )}
      disabled={props.disabled}
      checked={props.value}
      onCheckedChange={props.onValueChange}
    >
      <CheckboxIndicator>
        {props.value === 'indeterminate' ? <Minus className="tds-checkbox-icon" /> : <Check className="tds-checkbox-icon" />}
      </CheckboxIndicator>
    </ReactCheckbox>
  );
}

type CheckboxSurrogateProps = {
  checked: boolean;
  className?: string;
};

export const CheckboxSurrogate = ({ checked, className }: CheckboxSurrogateProps) => (
  <div className={ classNames(className, 'w-300 h-300 tds-checkbox', { 'checked': checked }) }>
    {checked ? <Check className="tds-checkbox-icon" /> : null}
  </div>
);
